import {css} from 'lit-element';
export default css`:host([fixed]) .alert{border-left-width:8px;border-radius:6px;padding:8px;padding-left:12px;padding-right:16px}:host([fixed]) .icon{margin-right:8px;width:24px;height:24px}:host([fixed]) .content{line-height:26px}:host([fixed]) .content ::slotted(p){margin-top:0}:host([fixed]) .content ::slotted(p:last-child){margin-bottom:0}
`;
